import { Banknote, Smartphone, Landmark, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useApp } from "@/context/AppContext";

const METHODS = [
  { v: "Cash", label: "Cash", Icon: Banknote },
  { v: "UPI", label: "UPI", Icon: Smartphone },
  { v: "Bank", label: "Online bank transfer", Icon: Landmark },
];

export const PaymentFields = ({ form, set, saved }) => {
  const { t } = useApp();
  const same = saved && saved.method === form.payment_method;
  return (
    <div className="space-y-4">
      <div className="grid gap-3">
        {METHODS.map(({ v, label, Icon }) => (
          <button key={v} type="button" onClick={() => set({ payment_method: v })} data-testid={`pay-${v.toLowerCase()}`}
            className={`flex h-16 items-center gap-4 rounded-2xl border-2 px-4 text-left text-base font-semibold transition-colors ${form.payment_method === v ? "border-[#2E9E6B] bg-[#2E9E6B]/10 text-[#0D3B2B]" : "border-[#D2E0D8] bg-white text-[#4A6358]"}`}>
            <Icon className="h-6 w-6 text-[#2E9E6B]" /> {t(label)}
          </button>
        ))}
      </div>
      {form.payment_method === "UPI" && (
        <div className="space-y-1">
          <label className="text-sm font-semibold text-[#0D3B2B]">{t("UPI ID")}</label>
          <Input data-testid="upi-input" className="h-12 rounded-xl" autoCapitalize="none" placeholder={same && saved.upi_masked ? `${saved.upi_masked} (${t("saved — leave blank to keep")})` : "name@okaxis"}
            value={form.upi_id} onChange={(e) => set({ upi_id: e.target.value.trim() })} />
        </div>
      )}
      {form.payment_method === "Bank" && (
        <div className="space-y-3">
          <Input data-testid="bank-holder-input" className="h-12 rounded-xl" placeholder={(same && saved.holder) || t("Account holder name")}
            value={form.bank_holder} onChange={(e) => set({ bank_holder: e.target.value })} />
          <Input data-testid="bank-account-input" className="h-12 rounded-xl" inputMode="numeric" autoComplete="off"
            placeholder={same && saved.account_last4 ? `****${saved.account_last4} (${t("saved — leave blank to keep")})` : t("Account number")}
            value={form.bank_account} onChange={(e) => set({ bank_account: e.target.value.replace(/\D/g, "") })} />
          <Input data-testid="bank-ifsc-input" className="h-12 rounded-xl uppercase" placeholder={(same && saved.ifsc) || t("IFSC code, e.g. SBIN0001234")}
            value={form.bank_ifsc} onChange={(e) => set({ bank_ifsc: e.target.value.toUpperCase() })} />
        </div>
      )}
      {form.payment_method !== "Cash" && (
        <p className="flex items-start gap-2 text-xs text-[#4A6358]"><ShieldCheck className="h-4 w-4 shrink-0 text-[#2E9E6B]" />{t("Your payment details are stored encrypted. We only ever show the last 4 digits.")}</p>
      )}
    </div>
  );
};
